import React from "react";

export const BarChart23 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={60} height={28} rx={1} fill="#F1F2F6" />

    <line
      x1={2}
      y1={25}
      x2={58}
      y2={25}
      fill="none"
      stroke="#8E97A9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
    />
    <g fill="#8E97A9">
      <rect x={3} y={19} width={2.73} height={5} />
      <rect x={6.64} y={16} width={2.73} height={8} />
      <rect x={10.27} y={13} width={2.73} height={11} />
      <rect x={13.91} y={13} width={2.73} height={11} />
      <rect x={17.55} y={3} width={2.73} height={21} />
      <rect x={21.18} y={17} width={2.73} height={7} />
      <rect x={24.82} y={19} width={2.73} height={5} />
      <rect x={28.45} y={19} width={2.73} height={5} />
      <rect x={32.09} y={19} width={2.73} height={5} />
      <rect x={35.73} y={16} width={2.73} height={8} />
      <rect x={39.36} y={13} width={2.73} height={11} />
      <rect x={43} y={15} width={2.73} height={9} />
      <rect x={46.64} y={4} width={2.73} height={20} />
      <rect x={50.27} y={7} width={2.73} height={17} />
      <rect x={54} y={6} width={2.73} height={18} />
    </g>
  </g>
);
